export { AudioSvg, type AudioSvgProps } from './AudioSvg';
